import {Component, inject} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {Store} from '@ngrx/store';
import {TranslatePipe} from '@ngx-translate/core';
import {selectBrokerLogo} from '../../store/contact/contact.selectors';
import {AppState} from '../../store/store';
import {HeaderPanelComponent} from '../header-panel/header-panel.component';
import {LangMenuComponent} from '../lang-menu/lang-menu.component';
import {SquareIconButtonComponent} from '../square-icon-button/square-icon-button.component';
import {logout} from '../../store/auth/auth.actions';
import {selectLoggedIn} from '../../store/auth/auth.selectors';

@Component({
  selector: 'app-header-menu-dialog',
  imports: [TranslatePipe, MatButton, LangMenuComponent, SquareIconButtonComponent, HeaderPanelComponent, AsyncPipe],
  templateUrl: './header-menu-dialog.component.html',
  styleUrl: './header-menu-dialog.component.scss',
})
export class HeaderMenuDialogComponent {

  private store: Store<AppState> = inject(Store<AppState>);

  private dialogRef: MatDialogRef<HeaderMenuDialogComponent> = inject(MatDialogRef<HeaderMenuDialogComponent>);

  readonly brokerLogo$ = this.store.select(selectBrokerLogo);

  readonly loggedIn$ = this.store.select(selectLoggedIn);

  onClose(): void {
    this.dialogRef.close();
  }

  handleLogout(): void {
    this.store.dispatch(logout());
    this.onClose();
  }

}
